
















import {Vue, Component, Watch, Prop} from "vue-property-decorator";

@Component
export default class HowToBody extends Vue {}
